(function () {
  if (window.__autoGiftLoaded) return;
  window.__autoGiftLoaded = true;

  const cfg = window.AutoGiftConfig;
  if (!cfg || !cfg.triggerVariantIds || !cfg.giftVariantId) return;

  const TRIGGERS = new Set(cfg.triggerVariantIds.map(String));
  const GIFT = String(cfg.giftVariantId);
  const PROP_KEY = '_auto_gift';
  const PROP_VAL = 'true';
  const GIFT_QTY_CAP = 1;

  let mutating = false;
  let pending = false;

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function hasTrigger(cart) {
    return cart.items.some((it) => TRIGGERS.has(String(it.variant_id)));
  }

  function autoGiftLines(cart) {
    return cart.items.filter(
      (it) =>
        String(it.variant_id) === GIFT &&
        it.properties &&
        it.properties[PROP_KEY] === PROP_VAL
    );
  }

  async function addGift(qty) {
    const fd = new FormData();
    fd.append('items[0][id]', GIFT);
    fd.append('items[0][quantity]', String(qty));
    fd.append('items[0][properties][' + PROP_KEY + ']', PROP_VAL);
    fd.append('sections', 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd,
    });
    return r.json();
  }

  async function changeLine(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    });
    return r.json();
  }

  function refreshIconBubble(parsed) {
    const html = parsed && parsed.sections && parsed.sections['cart-icon-bubble'];
    if (!html) return;
    const target = document.getElementById('cart-icon-bubble');
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (target && source) target.innerHTML = source.innerHTML;
  }

  async function reconcile() {
    if (mutating) {
      pending = true;
      return;
    }
    mutating = true;
    try {
      const cart = await getCart();
      const want = hasTrigger(cart) ? GIFT_QTY_CAP : 0;

      const lines = autoGiftLines(cart);
      const have = lines.reduce((s, l) => s + l.quantity, 0);

      if (want === have && lines.length <= 1) return;

      let result;
      if (lines.length > 1) {
        // Collapse duplicate auto-gift lines to a single line at qty `want`.
        for (let i = 1; i < lines.length; i++) {
          await changeLine(lines[i].key, 0);
        }
        if (lines[0].quantity !== want) {
          result = await changeLine(lines[0].key, want);
        }
      } else if (want > have) {
        result = await addGift(want - have);
      } else if (want < have) {
        result = await changeLine(lines[0].key, want);
      }

      if (result) refreshIconBubble(result);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const fresh = await getCart();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-gift', cartData: fresh });
      }
    } catch (err) {
      console.error('[auto-gift]', err);
    } finally {
      mutating = false;
      if (pending) {
        pending = false;
        reconcile();
      }
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data && data.source === 'auto-gift') return;
      reconcile();
    });
  }

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = originalFetch.apply(this, arguments);
    if (!mutating && /\/cart\/(add|change|update|clear)(\.js)?($|\?)/.test(url)) {
      result.then(() => reconcile()).catch(() => {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
